import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

function Hotel(props) {
  const { specialMsg } = props;
  let msg = "Royal Hotel Sanremo";
  if (specialMsg) {
    msg =
      "Grazie per la risposta! Ci vediamo il 27 giugno alle ore 15:30 in Corso Imperatrice, 80, 18038 Sanremo IM";
  }
  return (
    <Card sx={{ backgroundColor: "transparent" }}>
      <CardMedia
        sx={{ height: 640 }}
        image="ricevimento.jpg"
        title="Royal Hotel Sanremo"
      />
      <CardContent sx={{ backgroundColor: "transparent" }}>
        <Typography
          gutterBottom
          variant="h5"
          component="div"
          sx={{
            fontFamily: '"Penna"',
            fontWeight: "bold",
            fontSize: "1.8rem",
            color: "#fff",
          }}
        >
          {msg}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontFamily: '"Penna"',
            fontWeight: "bold",
            fontSize: "1.8rem",
            color: "#fff",
          }}
        >
          Indirizzo: Corso Imperatrice, 80, 18038 Sanremo IM
        </Typography>
        {/* <Typography variant="subtitle1" color="text.secondary">
						Inizio ricevimento alle ore 17? 🍾
					</Typography> */}
      </CardContent>
      <CardActions>
        <Button
          size="small"
          color="secondary"
          variant="outlined"
          href="https://www.royalhotelsanremo.com/"
          sx={{
            color: "#fff",
            borderColor: "#fff",
          }}
        >
          Sito Web
        </Button>
      </CardActions>
    </Card>
  );
}

export default Hotel;
